export default {
  'feBasedError.title':
    'Whoops! Something went wrong on <color>Examod</color>.',
  'feBasedError.desc':
    "There's an unexpected error while processing your request. We will fix the problem as soon as possible.",
};
